<template>
    <div>
        <div>
            <report-header
                :title="title"
                :isShowDateRange="true"
                :formatDateRangeTitle="dateRange"
            />

            <b-card id="report-card">
                <!-- FOR SUMMARY -->
                <div id="report-body" class="w-100">
                    <div>
                        <p class="item-name">
                            Summary
                        </p>
                        <QTable
                            :columns="summaryHeaders"
                            :data="summaryData"
                            :rows-per-page-options="[0]"
                            virtual-scroll
                            virtual-scroll-slice-size="60"
                            hide-bottom
                            class="sticky-table"
                        >
                            <template
                                v-slot:bottom-row
                                v-if="
                                    summaryData.length == 0 &&
                                    !isLoading &&
                                    !isError
                                "
                            >
                                <q-tr>
                                    <q-td colspan="8"
                                        >No records available</q-td
                                    >
                                </q-tr>
                            </template>
                            <template v-slot:header="props">
                                <q-tr :props="props">
                                    <th
                                        v-for="col in props.cols"
                                        :key="col.name"
                                        class="sticky-header"
                                        :style="col.style"
                                    >
                                        <div
                                            v-if="col.field == 'date'"
                                            class="d-flex align-items-center"
                                        >
                                            <div
                                                @click="toggleExpandAll()"
                                                class="pr-2"
                                            >
                                                <i
                                                    class="cursor-pointer m-auto"
                                                    :class="
                                                        checkExpandIcon(
                                                            isExpandAll
                                                        )
                                                    "
                                                ></i>
                                            </div>
                                            <div>
                                                <strong
                                                    @click="toggleExpandAll()"
                                                    class="cursor-pointer"
                                                >
                                                    {{ col.label }}
                                                </strong>
                                            </div>
                                        </div>
                                        <strong v-else>{{ col.label }}</strong>
                                    </th>
                                </q-tr>
                                <q-tr :props="props" v-if="isHasExpand">
                                    <th
                                        colspan="8"
                                        class="sticky-header-inner py-0 pl-0 pr-1"
                                    >
                                        <table class="table table-hover m-0">
                                            <thead>
                                                <tr class="table-borderless">
                                                    <th
                                                        class="sticky-header-close column-close cursor-pointer"
                                                        @click="
                                                            () => {
                                                                innerHeaderClosed = true;
                                                            }
                                                        "
                                                    >
                                                        <i
                                                            class="fas fa-times"
                                                        ></i>
                                                    </th>
                                                    <th
                                                        v-for="header in innerHeaders"
                                                        :key="header.name"
                                                        :style="header.styles"
                                                        class="align-middle"
                                                    >
                                                        {{ header.name }}:
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </th>
                                </q-tr>
                                <q-linear-progress
                                    v-show="isLoading"
                                    class="sticky-loader"
                                    indeterminate
                                    color="dark"
                                    :style="
                                        isHasExpand ? 'top:96px' : 'top:48px'
                                    "
                                />
                            </template>
                            <template v-slot:body="props">
                                <q-tr
                                    :props="props"
                                    :key="`m_${props.rowIndex}`"
                                >
                                    <q-td
                                        v-for="col in props.cols"
                                        :key="col.name"
                                        :props="props"
                                    >
                                        <div
                                            v-if="col.name == 'date'"
                                            class="d-flex align-items-center"
                                        >
                                            <span
                                                @click="
                                                    toggleExpandItem(props.row)
                                                "
                                                class="pr-2"
                                            >
                                                <i
                                                    class="cursor-pointer"
                                                    :class="
                                                        checkExpandIcon(
                                                            props.row.expand
                                                        )
                                                    "
                                                ></i>
                                            </span>
                                            <div
                                                @click="
                                                    toggleExpandItem(props.row)
                                                "
                                                class="text-link"
                                            >
                                                {{ col.value }}
                                            </div>
                                        </div>
                                        <div v-else>
                                            {{ col.value }}
                                        </div>
                                    </q-td>
                                </q-tr>
                                <q-tr
                                    v-if="props.row.expand && props.row.data"
                                    :props="props"
                                    class="color-grey q-virtual-scroll--with-prev"
                                    :key="`e_${props.row.dateTimestamp}`"
                                    no-hover
                                >
                                    <q-td
                                        colspan="100%"
                                        class="border-left py-4 color-grey pl-0 pr-1"
                                    >
                                        <!-- Billing details by date -->
                                        <div class="table-responsive mb-0">
                                            <table
                                                class="table table-hover table-inner"
                                            >
                                                <thead>
                                                    <tr
                                                        class="table-borderless"
                                                    >
                                                        <th
                                                            class="column-close table-inner-header-close"
                                                        ></th>
                                                        <th
                                                            v-for="header in innerHeaders"
                                                            :key="header.name"
                                                            :style="
                                                                header.styles
                                                            "
                                                        >
                                                            {{ header.name }}:
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="item in props.row
                                                            .data.items"
                                                        :key="item.id"
                                                    >
                                                        <td
                                                            class="border-0"
                                                        ></td>
                                                        <td>
                                                            <a
                                                                class="text-capitalize"
                                                                :href="
                                                                    item.invoice_encoded_id
                                                                        ? env.APPS +
                                                                          'billing/invoice/view/' +
                                                                          item.invoice_encoded_id
                                                                        : ''
                                                                "
                                                            >
                                                                {{
                                                                    item[
                                                                        "inv_#"
                                                                    ]
                                                                }}
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <span
                                                                v-if="
                                                                    !isPatientClientNameBlank(
                                                                        item.client
                                                                    )
                                                                "
                                                            >
                                                                <client-name
                                                                    :use-router="
                                                                        USE_CLIENT_MODULE_VUE
                                                                    "
                                                                    :client="
                                                                        generateClientObject(
                                                                            item
                                                                        )
                                                                    "
                                                                />
                                                                <span
                                                                    v-if="
                                                                        item.client_no
                                                                    "
                                                                >
                                                                    ({{
                                                                        item.client_no
                                                                    }})</span
                                                                >
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <patient-name
                                                                v-if="
                                                                    !isPatientClientNameBlank(
                                                                        item.patient
                                                                    )
                                                                "
                                                                :use-router="
                                                                    USE_PATIENT_MODULE_VUE
                                                                "
                                                                :patient="
                                                                    generatePatientObject(
                                                                        item
                                                                    )
                                                                "
                                                                :showStatus="
                                                                    true
                                                                "
                                                            />
                                                            <span
                                                                v-if="
                                                                    item.patient_no
                                                                "
                                                            >
                                                                ({{
                                                                    item.patient_no
                                                                }})</span
                                                            >
                                                        </td>
                                                        <td>
                                                            <a
                                                                v-if="
                                                                    item.item_encoded_id
                                                                "
                                                                :href="
                                                                    env.APPS +
                                                                    'inventory/item/view/' +
                                                                    item.item_encoded_id
                                                                "
                                                                target="_blank"
                                                                >{{
                                                                    item.item
                                                                }}</a
                                                            >
                                                            <span v-else
                                                                >{{
                                                                    item.item
                                                                }}
                                                                <span
                                                                    class="text-lowercase"
                                                                    v-if="
                                                                        item.item_isactive ==
                                                                        '0'
                                                                    "
                                                                >
                                                                    (inactive)</span
                                                                ></span
                                                            >
                                                        </td>
                                                        <td>
                                                            {{
                                                                item[
                                                                    "provided by"
                                                                ]
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                formatQuantity(
                                                                    item.quantity
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                _toCurrency(
                                                                    item.subtotal
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                _toCurrency(
                                                                    item.discount
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                _toCurrency(
                                                                    item.tax
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                _toCurrency(
                                                                    item.lineTotal
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td
                                                            class="column-close border-0"
                                                        ></td>
                                                        <td colspan="6">
                                                            <strong
                                                                >Total:</strong
                                                            >
                                                        </td>
                                                        <td>
                                                            <strong>{{
                                                                _toCurrency(
                                                                    props.row
                                                                        .data
                                                                        .total_subtotal
                                                                )
                                                            }}</strong>
                                                        </td>
                                                        <td>
                                                            <strong>{{
                                                                _toCurrency(
                                                                    props.row
                                                                        .data
                                                                        .total_discount
                                                                )
                                                            }}</strong>
                                                        </td>
                                                        <td>
                                                            <strong>{{
                                                                _toCurrency(
                                                                    props.row
                                                                        .data
                                                                        .total_tax
                                                                )
                                                            }}</strong>
                                                        </td>
                                                        <td>
                                                            <strong>{{
                                                                _toCurrency(
                                                                    props.row
                                                                        .data
                                                                        .total_linetotal
                                                                )
                                                            }}</strong>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </q-td>
                                </q-tr>
                            </template>
                        </QTable>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import { QTable } from "quasar";
import { DateTime } from "luxon";
import Report from "@/mixins/report";
import PatientName from "@/components/commons/patient-name";
import ClientName from "@/components/commons/client-name";
import CREPORT from "@/constants/report";
import "@/css/quasar-table.css";
import { forEach, sortBy, some, filter, merge, chunk } from "lodash";
import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;

const ICON_COLLAPSE = "fas fa-chevron-circle-right";
const ICON_EXPAND = "fas fa-chevron-circle-down";
const CHUNKSIZE = 60;

export default {
    mixins: [Report],
    components: {
        QTable,
        ClientName,
        PatientName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("day"),
                    end: this.getEndDate("day")
                };
            }
        }
    },
    data() {
        return {
            isLoading: true,
            isError: false,
            summaryData: [],
            title: "Billing Detail By Invoice",
            dateRange: "",
            isExpandAll: false,
            detailsDataResult: [],
            innerHeaderClosed: false,
            abortController: [],
            indexAxios: 0,
            innerHeaders: [
                { name: "Invoice", styles: "width: 200px;" },
                { name: "Client", styles: "width: 140px;" },
                { name: "Patient", styles: "width: 140px;" },
                { name: "Item", styles: "width: 130px;" },
                { name: "Provided By", styles: "width: 130px;" },
                { name: "Quantity", styles: "width: 130px;" },
                { name: "Subtotal", styles: "width: 115px;" },
                { name: "Discount", styles: "width: 110px" },
                { name: "Tax", styles: "width: 110px" },
                { name: "Line Total", styles: "width: 115px" }
            ]
        };
    },
    computed: {
        isHasExpand() {
            return (
                some(this.summaryData, { expand: true }) &&
                !this.innerHeaderClosed
            );
        },
        summaryHeaders() {
            return [
                {
                    name: "date",
                    label: "Date",
                    field: "date",
                    align: "left",
                    style: "white-space: nowrap; min-width: 122px"
                },
                {
                    name: "invoice_count",
                    label: "Invoice Count",
                    field: "invoice_count",
                    align: "left",
                    style: "white-space: nowrap; min-width: 122px"
                },
                {
                    name: "line_items_count",
                    label: "Line Items Count",
                    field: "line_items_count",
                    align: "left",
                    style: "white-space: nowrap; min-width: 143px"
                },
                {
                    name: "subtotal",
                    label: "Subtotal",
                    field: row => row.subtotal,
                    format: (val, row) => {
                        return this._toCurrency(row.subtotal);
                    },
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "discount",
                    label: "Discount",
                    field: row => row.discount,
                    format: (val, row) => {
                        return this._toCurrency(row.discount);
                    },
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "tax",
                    label: "Tax",
                    field: row => row.tax,
                    format: (val, row) => {
                        return this._toCurrency(row.tax);
                    },
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "late_fee",
                    label: "Late Fee",
                    field: row => row.late_fee,
                    format: (val, row) => {
                        return this._toCurrency(row.late_fee);
                    },
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "total",
                    label: "Total",
                    field: row => row.total,
                    format: (val, row) => {
                        return this._toCurrency(row.total);
                    },
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                }
            ];
        }
    },
    async mounted() {
        let self = this;
        self.data.isShowDateRange = true;
        self.data.datePickerOptionDefault = 1;
        self.dynamicPageTitle(self.title);
        await self._getSetting();

        self.data.start = self.getStartDate("day");
        self.data.end = self.getEndDate("day");
        self.data.from = self.converToUnix(self.data.start);
        self.data.to = self.converToUnix(self.data.end);
        self.fetchData(self.indexAxios);

        self.$root.$on("report-filter-date-range:refresh", self.init);
    },
    beforeDestroy: function () {
        this.data.datePickerOptionDefault = null;
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        init(params) {
            if (params) {
                this.data.from = params.from;
                this.data.to = params.to;
                this.data.start = params.start;
                this.data.end = params.end;
            }

            if (this.abortController.length > 0) {
                this.abortController[this.indexAxios].abort();
            }
            this.indexAxios++;
            this.dateRange = "";
            this.fetchData(this.indexAxios);
        },

        async fetchData(indexAxios) {
            let self = this;

            self.summaryData = [];
            self.isLoading = true;
            self.isError = false;
            self.isExpandAll = false;

            self.toggleOptions(false);
            self.abortController[indexAxios] = new AbortController();
            self.dateRange = self.getDateRange(self.data.from, self.data.to);

            Axios.get(
                `${baseURL}report/reports/${CREPORT.TYPE.BILLING_DETAIL}`,
                {
                    signal: self.abortController[indexAxios].signal,
                    params: { from: self.data.from, to: self.data.to }
                }
            )
                .then(res => {
                    if (
                        res &&
                        res.data.response.message &&
                        res.data.response.message.code == 200
                    ) {
                        const response = res.data.response;
                        self.dateRange = self.getDateRange(
                            response.resource.start_date,
                            response.resource.end_date
                        );
                        self.detailsDataResult =
                            response.resource.results.query_results;

                        Promise.all([
                            self.renderData(response.resource.results)
                        ]).then(() => {
                            self.endFetching();
                        });
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    if (!self.abortController[indexAxios].signal.aborted) {
                        console.error(e.message);
                        self.isError = true;
                        self.endFetching();
                        self._message(
                            "Error: Unable to get the report",
                            "danger"
                        );
                    }
                });
        },
        async renderData(results) {
            let self = this;
            // RENDER SUMMARY
            const summaryData = results.summary_data;

            if (Object.keys(summaryData).length > 0) {
                const arraySummary = Object.entries(
                    summaryData
                ).map(([key, value]) => merge(value, { date: key }));
                const chunksSummary = chunk(arraySummary, CHUNKSIZE);
                forEach(chunksSummary, chunk => {
                    forEach(chunk, summary => {
                        summary.dateTimestamp = self.formatDateToSeconds(
                            summary.date
                        );
                        summary.expand = false;
                        self.summaryData.push(summary);
                    });
                });
                self.summaryData = sortBy(this.summaryData, ["dateTimestamp"]);
            }
        },
        isPatientClientNameBlank(name) {
            // somehow there is some data return value with " (deleted)", the name is blank
            return this.capitalize(name.replace("(deleted)", "")).replaceAll(
                " ",
                ""
            ) === ""
                ? true
                : false;
        },
        generatePatientObject(row) {
            const isDeleted = this.capitalize(row.patient).includes(
                "(deleted)"
            );
            return {
                id: row.patient_id,
                name: this.capitalize(row.patient.replace("(deleted)", "")),
                encoded_id: isDeleted ? null : row.patient_encoded_id,
                isactive: !isDeleted
            };
        },
        generateClientObject(row) {
            const isDeleted =
                this.capitalize(row.client).includes("(deleted)") ||
                row.client_encoded_id == null;

            return {
                id: row.client_id,
                name: this.capitalize(row.client.replace("(deleted)", "")),
                encoded_id: isDeleted ? null : row.client_encoded_id,
                isactive: !isDeleted
            };
        },
        formatDateToSeconds(date) {
            return DateTime.fromFormat(
                date,
                this._getLuxonFormat()
            ).toSeconds();
        },
        endFetching() {
            this.toggleOptions(true);
            this.isLoading = false;
        },
        toggleOptions(value) {
            this.data.exportOption = value;
            this.data.refreshOption = value;
        },
        formatQuantity(quantity) {
            const split = quantity.split(" ", 2);
            return (
                parseFloat(split[0]).toFixed(3) +
                (split[1] ? " " + split[1] : "")
            );
        },
        renderDetails(row) {
            // RENDER DETAILS
            let self = this;
            let detailsDataByDate = filter(self.detailsDataResult, {
                date: row.date
            });

            row.data = {
                date: row.date,
                dateTimestamp: row.dateTimestamp,
                items: []
            };
            if (Object.keys(detailsDataByDate).length > 0) {
                const chunksInvoices = _.chunk(detailsDataByDate, CHUNKSIZE);

                row.data.total_subtotal = 0;
                row.data.total_discount = 0;
                row.data.total_tax = 0;
                row.data.total_linetotal = 0;
                forEach(chunksInvoices, chunks => {
                    forEach(chunks, item => {
                        row.data.items.push(item);
                        row.data.total_subtotal += parseFloat(item.subtotal);
                        row.data.total_discount += parseFloat(item.discount);
                        row.data.total_tax += parseFloat(item.tax);
                        row.data.total_linetotal += parseFloat(item.lineTotal);
                    });
                });
            }
        },
        async toggleExpandItem(row) {
            let self = this;
            self.isLoading = true;
            await self.timer(1); // to able the loading be shown before render data below
            row.expand = !row.expand;

            if (row.expand) {
                self.innerHeaderClosed = false;
            }

            // check if all data expand same value, change this.isExpandAll to be same value
            if (!some(self.summaryData, { expand: !row.expand })) {
                self.isExpandAll = row.expand;
            }
            if (row.expand) {
                await self.renderDetails(row);
            }
            self.isLoading = false;
        },
        async toggleExpandAll() {
            let self = this;
            self.isLoading = true;
            await self.timer(1); // to able the loading be shown before render data below
            self.isExpandAll = !self.isExpandAll;
            self.innerHeaderClosed = !self.isExpandAll;

            self.summaryData = await self.summaryData.map(result => {
                result.expand = self.isExpandAll;
                if (result.expand) {
                    self.renderDetails(result);
                }
                return result;
            });
            self.isLoading = false;
        },
        checkExpandIcon(isExpand) {
            return isExpand ? ICON_EXPAND : ICON_COLLAPSE;
        }
    }
};
</script>
<style scoped>
table {
    table-layout: fixed;
    width: 100%;
}

table th {
    vertical-align: middle;
}
</style>
